import React, { useEffect, useState } from "react";
import { notification, Spin } from "antd";
import PaginationWidget from "../../../widgets/PaginationWidget";
import SlidesApi from "../../../api-services/slides-api.service";
import type { Banner } from "../../../interfaces/banner.interface";

const slidesApi = new SlidesApi();

// The "view all" destination for the homepage's Limited Time Promo carousel
// (see components/LimitedTimePromo), shown at /web/limited-promo. Same banner
// artwork as the carousel, laid out in a responsive grid with real pagination
// instead of a horizontal scroll.
export default function LimitedPromoListing() {
  const [promos, setPromos] = useState<Banner[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    slidesApi.getSlides("limited_promo", currentPage)
      .then(({ slides, totalPages }) => {
        setPromos(slides);
        setTotalPages(totalPages);
      })
      .catch(() => notification.error({ message: "Something went wrong while loading Limited Time Promo." }))
      .finally(() => setLoading(false));
  }, [currentPage]);

  return (
    <div id="limited-promo-listing-v2">
      <div className="limited-promo-listing-v2__content">
        <div className="limited-promo-listing-v2__header">
          <h1>Limited Time Promo</h1>
        </div>
        <Spin size="large" className="loader" spinning={loading} />
        {!loading && promos.length === 0 && (
          <p className="limited-promo-listing-v2__empty">No promotions at the moment.</p>
        )}
        {!loading && promos.length > 0 && (
          <div className="limited-promo-listing-v2__grid">
            {promos.map((promo) => {
              const image = (
                <picture>
                  <source media="(max-width: 599px)" srcSet={promo.mobileImage || promo.desktopImage} />
                  <img src={promo.desktopImage} alt={promo.title || "Promotion"} />
                </picture>
              );

              return (
                <div key={promo.id} className="limited-promo-listing-v2__card">
                  {promo.url ? (
                    <a href={promo.url} target={promo.target} rel="nofollow">
                      {image}
                    </a>
                  ) : image}
                </div>
              );
            })}
          </div>
        )}
        {!loading && totalPages > 1 && (
          <PaginationWidget totalItems={totalPages} current={currentPage} maxItemsPerPage={1} pageChange={setCurrentPage} />
        )}
      </div>
    </div>
  );
}
